import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../../assets/images/Elderly_financial.png'


const _hoisted_1 = {
  key: 0,
  class: "account-actions pdt-0"
}
const _hoisted_2 = { class: "action-buttons justify-content-end" }
const _hoisted_3 = {
  key: 1,
  class: "no-bene-card"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Elderly Financial",
  width: "248",
  height: "248"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Add new beneficiaries and set their funds allocation", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_BeneficiaryProfile = _resolveComponent("BeneficiaryProfile")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MessageCard, {
      message: "For your protection and for the benefit of your family, we encourage you to keep beneficiary information up to date. The displayed information is from your records with the Fund Office. If the information is not correct, click on the applicable beneficiary in order to update. If you wish to add a new beneficiary, click the button on the upper right side of your screen.",
      type: "primary",
      iconClass: "iatse-icon-alarm",
      classes: "info_card_full"
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass({ 'plan-content': true, 'centered': !_ctx.beneficiaries?.length || !_ctx.beneficiaries })
        }, [
          (_ctx.beneficiaries?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("a", {
                    href: "",
                    class: "btn btn-primary plan-modal",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleAdd && _ctx.handleAdd(...args)), ["prevent"]))
                  }, " Add Beneficiary ")
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.beneficiaries?.length || !_ctx.beneficiaries)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _hoisted_5,
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-primary plan-modal",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleAdd && _ctx.handleAdd(...args)), ["prevent"]))
                }, " Add Beneficiary ")
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.beneficiaries, (beneficiary, key) => {
            return (_openBlock(), _createBlock(_component_BeneficiaryProfile, {
              key: key,
              beneficiary: beneficiary
            }, null, 8, ["beneficiary"]))
          }), 128))
        ], 2))
  ], 64))
}